<template>
  <div>
    <div class="contBody">
      <div class="contList">
        <div class="headCont">
          <div class="title">个人信息</div>
          <ComJb v-if="comShow" :info="info" @show="jbShowJs" />
          <div class="cont" v-if="!comShow">
            <div class="img">
              <img :src="$imgUrl + memberinfo.avatars" alt="" />
            </div>
            <div class="box">
              <div class="nameBox">
                <div class="name">{{ memberinfo.realname }}</div>
                <div class="txt" @click="comShow = true">编辑</div>
              </div>
              <div class="textBox">
                <div class="txt">{{ company.name }}</div>
                <div class="shu"></div>
                <div class="txt">{{ company.trade_cn }}</div>
              </div>
              <div class="textBox">
                <div class="txt">{{ memberinfo.phone }}</div>
                <div class="shu"></div>
                <div class="txt">{{ memberinfo.weixin }}</div>
                <div class="shu"></div>
                <div class="txt">{{ memberinfo.email }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="comCont">
          <div class="title">
            <div class="name"></div>
            <!-- <div class="text" @click="ccShow = true">退出公司</div> -->
            <div class="text" @click="mqvisible = true">退出公司</div>
          </div>
          <div class="box">
            <div class="img">
              <img :src="$imgUrl + company.logo" alt="" />
            </div>
            <div class="txtBox">
              <div class="name">{{ company.name }}</div>
              <div class="txt">{{ company.trade_cn }}</div>
              <div class="tb dis-cent" @click="xxJump">修改信息</div>
            </div>
          </div>
        </div>
        <div class="peoCont" v-if="list.length != 0">
          <div class="title">
            <div class="name">人才收藏</div>
            <div class="text" @click="scJump">
              查看更多<span class="iconfont icon-enter enter"></span>
            </div>
          </div>
          <div class="boxs">
            <div class="box" v-for="(item, index) in list">
              <div class="img">
                <img :src="$imgUrl + item.member_info.avatars" alt="" />
              </div>
              <div class="boxCont">
                <div class="name">{{ item.member_info.realname }}</div>
                <div class="text c-1">
                  {{ item.member_info.current_cn }}
                </div>
              </div>
              <div class="btn dis-cent" @click="scClick(item, index)">
                {{ item.is_favorite ? "收藏" : "取消收藏" }}
              </div>
            </div>
          </div>
        </div>
        <div class="comCont">
          <div class="title">
            <div class="name">曝光趋势</div>
          </div>
          <div class="qsbox">
            <Qushi1 :manageList="manageList" />
          </div>
        </div>
      </div>
      <div class="contRit">
        <div class="title">更多功能</div>
        <div class="box">
          <!-- <div class="contBox">
            <div class="icon dis-cent">
              <div
                class="iconfont icon-coordinates_fill coordinates_fill"
              ></div>
            </div>
            <div class="name">地址管理</div>
          </div> -->
          <div class="contBox" @click="fkClick">
            <div class="icon dis-cent">
              <div class="iconfont icon-wentifankui-moren moren"></div>
            </div>
            <div class="name">问题反馈</div>
          </div>
          <!-- <div class="contBox">
            <div class="icon dis-cent">
              <div class="iconfont icon-rencai moren"></div>
            </div>
            <div class="name">切换为人才</div>
          </div> -->
        </div>
      </div>
    </div>
    <a-modal
      v-model="mqvisible"
      title="提示"
      @ok="mqhandleOk"
      cancelText="取消"
      okText="确定"
    >
      <p>是否确定退出公司</p>
    </a-modal>
    <ChangeCom v-if="ccShow" @show="ccShow = false" />
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  Popconfirm,
  Modal,
} from "ant-design-vue";
import Qushi1 from "../../component/qushi1.vue";
import ChangeCom from "./changeCom.vue";
import ComJb from "./comJb.vue";

export default {
  components: {
    Qushi1,
    ChangeCom,
    ComJb,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
  },
  name: "",
  data() {
    return {
      comShow: false,
      ccShow: false,
      company: {},
      member: {},
      memberinfo: {},
      list: [],
      manageList: [],
      mqvisible: false,
    };
  },
  created() {
    this.get();
    this.listGet();
    this.manageget();
  },
  methods: {
    mqhandleOk() {
      this.$post("/nozzle/web/company_out").then((res) => {
        if (res.data.status == 1) {
          this.$router.replace({
            path: "/index",
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    manageget() {
      this.$get("/nozzle/web/company_graphs", {
        type: 2,
      }).then((res) => {
        for (let i = 0; i < res.charts.length; i++) {
          const e = res.charts[i];
          e.value = e.number;
        }
        this.manageList = res.charts;
      });
    },
    scClick(item, i) {
      this.$post("/nozzle/web/favorite_save", {
        id: item.member_id,
        genre: 3,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.list[i].is_favorite = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    scJump() {
      // console.log(1);
      // this.$router.push({
      //   path: "/gongsi/peoSc",
      // });
      window.open("#/gongsi/peoSc");
    },
    get() {
      this.$get("/nozzle/web/member_info_header").then((res) => {
        this.info = res;
        this.company = res.company;
        this.member = res.member;
        this.memberinfo = res.memberinfo;
      });
    },
    listGet() {
      this.$get("/nozzle/web/company_favorite", {
        pageSize: 3,
      }).then((res) => {
        console.log(res);
        if (res.data) {
          this.list = res.data;
        }
      });
    },
    fkClick() {
      // this.$router.push({
      //   path: "/fankui",
      //   query: {},
      // });
      window.open("#/fankui");
    },
    xxJump() {
      // this.$router.push({
      //   path: "/zcGs",
      // });
      window.open("#/zcGs");
    },
    jbShowJs(data) {
      if (data) {
        this.get();
      }
      this.comShow = false;
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.contBody {
  width: 1280px;
  margin: auto;
  padding-top: 15px;
  display: flex;

  .contList {
    width: calc(100% - 400px);
    border-radius: 5px;

    .headCont {
      border-radius: 10px;
      background-color: #fff;
      overflow: hidden;

      .title {
        padding: 20px 30px 0;
        font-weight: 600;
        font-size: 16px;
      }

      .cont {
        padding: 20px 30px;
        display: flex;

        .img {
          width: 75px;
          height: 75px;
          border-radius: 50%;
        }

        .box {
          width: calc(100% - 75px);
          box-sizing: border-box;
          padding-left: 15px;

          .nameBox {
            display: flex;
            align-items: center;
            justify-content: space-between;

            .name {
              font-size: 20px;
              font-weight: 600;
            }

            .txt {
              color: #f51515;
              cursor: pointer;
            }
          }

          .textBox {
            display: flex;
            align-items: center;
            margin-top: 8px;
            color: #29354d;

            .shu {
              width: 1px;
              height: 15px;
              background-color: #ebebeb;
              margin: 0 15px;
            }
          }
        }
      }

      .ysCont {
        .box {
          padding: 0 30px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .name {
            font-size: 18px;
            font-weight: 600;
          }

          .yuan {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background-color: #faeded;
            color: #f51515;

            .iconfont {
              font-weight: 600;
              cursor: pointer;
            }
          }
        }

        .text {
          padding: 0 30px 20px;
          margin-top: 15px;
          color: #9c9c9c;
          margin-bottom: 10px;
        }
      }
    }

    .peoCont {
      border-radius: 10px;
      background-color: #fff;
      overflow: hidden;
      margin-top: 15px;

      .title {
        padding: 20px 30px 0;
        font-weight: 600;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .text {
          color: #228aeb;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;
        }

        .enter {
          font-size: 12px;
        }
      }

      .boxs {
        display: flex;
        padding: 20px 30px;
        .box {
          display: flex;
          box-shadow: 0 0 4px 2px #ebebeb;
          padding: 10px;
          border-radius: 5px;
          width: calc(33.33% - 10px);
          margin-right: 15px;
          align-items: center;

          .img {
            width: 60px;
            height: 60px;
            border-radius: 10px;
            overflow: hidden;
          }

          .boxCont {
            width: calc(100% - 120px);
            height: 60px;
            padding-left: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .text {
              font-size: 12px;
              color: #888;
              margin-top: 5px;
            }
          }

          .btn {
            width: 60px;
            height: 30px;
            background-color: #228aeb;
            color: #fff;
            font-size: 12px;
            border-radius: 5px;
          }

          cursor: pointer;
        }
      }
    }

    .comCont {
      border-radius: 10px;
      background-color: #fff;
      overflow: hidden;
      margin-top: 15px;

      .title {
        padding: 20px 30px 0;
        font-weight: 600;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .text {
          color: #228aeb;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;
        }
      }

      .box {
        display: flex;
        padding: 20px 30px;

        .img {
          width: 75px;
          height: 75px;
          border-radius: 5px;
        }

        .txtBox {
          width: calc(100% - 75px);
          padding-left: 15px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          .name {
            font-size: 16px;
            margin-bottom: 5px;
            color: #333;
          }

          .tb {
            position: absolute;
            top: 0;
            right: 0;
            border: 1px solid #228aeb;
            color: #228aeb;
            width: 90px;
            height: 35px;
            border-radius: 5px;
            cursor: pointer;
          }
        }
      }

      .qsbox {
        height: 300px;
        padding: 0 30px 20px;
      }
    }
  }

  .contRit {
    width: calc(400px - 15px);
    margin-left: 15px;
    background-color: #fff;

    .title {
      padding: 20px 30px;
      font-weight: 600;
      font-size: 16px;
    }

    .box {
      display: flex;
      flex-wrap: wrap;

      .contBox {
        width: 33.33%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;

        .icon {
          width: 50px;
          height: 50px;
          border-radius: 10px;
          background-color: #228aeb;
          color: #fff;
          font-size: 14px;

          .coordinates_fill {
            font-size: 27px;
          }

          .moren {
            font-size: 21px;
          }
        }

        .name {
          margin-top: 7px;
        }
      }
    }
  }
}
</style>
